let uid = 0;
let loaderElement = null;
const loaders = {};
global.load = loaders;

// process when dom ready
document.addEventListener("DOMContentLoaded", () => {
  processOpts();
});
export default function busy(promise, options) {
  let opts = options || {};
  findLoader();

  let id = ++uid;
  loaders[id] = opts;
  if (promise && promise.then)
    promise.then(complete, (ex) => {
      complete();
      throw ex;
    });
  let done = false;
  processOpts();
  return complete;

  function complete() {
    if (done) return;
    const loader = findLoader();

    if (!loader) {
      done = true;
      return;
    }

    delete loaders[id];
    done = true;

    // Only detach loaders that live directly under body. `body.contains(node)` is true for
    // any descendant, but removeChild requires a direct child — nested `#loader` (e.g.
    // Calendar.aspx inside UpdatePanel) would throw NotFoundError otherwise.
    if (loader.parentNode === document.body) {
      document.body.removeChild(loader);
      if (loaderElement === loader) {
        loaderElement = null;
      }
    }

    if (Object.keys(loaders).length === 0) {
      processVisible();
    } else {
      processOpts();
    }
  }
}

function findLoader() {
  if (loaderElement) return loaderElement;
  loaderElement = document.querySelector("#loader");
  if (!loaderElement) {
    loaderElement = document.createElement("div");
    loaderElement.setAttribute("id", "loader");
    loaderElement.setAttribute("class", "loader");
    document.body.appendChild(loaderElement);
  }
  return loaderElement;
}

function processVisible() {
  let loader = findLoader();
  let isLoading = !!Object.values(loaders).some((l) => l);

  if (isLoading) {
    showLoader(loader);
  } else if (
    !loader.classList.contains("loader-initialload") &&
    !loader.classList.contains("loader-immediate")
  ) {
    hideLoader(loader);
  } else {
    setTimeout(() => {
      let isLoading2 = !!Object.values(loaders).some((l) => l);
      if (!isLoading2) {
        hideLoader(loader);
      }
    }, 150);
  }
}

function processOpts() {
  let loader = findLoader();
  let hasImmediate = !!Object.values(loaders).some((l) => l.immediate);
  if (loader.classList.contains("loader-hidden")) {
    loader.classList.remove("loader-initialload");
  }
  if (hasImmediate) {
    loader.classList.add("loader-immediate");
    loader.classList.remove("loader");
  } else if (loader.classList.contains("loader-hidden")) {
    loader.classList.remove("loader-immediate");
  }

  processVisible();
}

function showLoader(loader) {
  if (
    !loader.classList.contains("loader-initialload") &&
    !loader.classList.contains("loader-immediate")
  ) {
    loader.classList.add("loader");
  }

  loader.classList.remove("loader-hidden");
}

function hideLoader(loader) {
  loader.classList.remove("loader");
  loader.classList.add("loader-hidden");
}
